export enum AnnotationSubject {
  WIDGET = 'Widget',
  SIGN_HERE = 'Sign Here',
  SIGNATURE = 'Signature',
  INITIAL_HERE = 'Initial Here',
  DRAFT = 'Draft',
  DATE = 'Date',
}

export enum StampAnnotation {
  DATE = 'assets/date.svg',
  NAME = 'assets/name.svg',
  SIGN_HERE = 'assets/sign_here.svg',
  INITIAL_HERE = 'assets/inititals_here.svg',
}

const widgetField = 'WidgetField'
const inputWidgetField = `Input_${widgetField}`

export enum AnnotationField {
  WIDGET_FIELD = `${widgetField}`,
  SIGNATURE = `Signature_${widgetField}`,
  INPUT = `${inputWidgetField}`,
  DATE = `Date_${inputWidgetField}`,
  NAME = `Name_Text_${inputWidgetField}`,
  INITIAL_HERE = `Initial_Here_Text_${inputWidgetField}`,
}

export enum AnnotationAction {
  ADD = 'add',
  DELETE = 'delete',
}

export enum AnnotationDisplayAuthor {
  AGENT = 'Sign Here',
  RECIPIENT = 'Sign Here',
}

export enum ViewerMessageType {
  VIEWER_LOADED = 'VIEWER_LOADED',
  LOAD_DOCUMENT = 'LOAD_DOCUMENT',
  CLOSE_DOCUMENT = 'CLOSE_DOCUMENT',
  DOCUMENT_LOADED = 'DOCUMENT_LOADED',
  CONFIGURE_INITIAL = 'CONFIGURE_INITIAL',
  OPEN_DOCUMENT_URL = 'OPEN_DOCUMENT_URL',
  SAVE_QUICK_SIGN_DOCUMENT_DATA = 'SAVE_QUICK_SIGN_DOCUMENT_DATA',
  GET_QUICK_SIGN_DOCUMENT_DATA = 'GET_DOCUMENT_DATA',
  SAVE_QUICK_SIGN_SIGNATURES = 'SAVE_QUICK_SIGN_SIGNATURES',
  GET_QUICK_SIGN_SIGNATURES = 'GET_QUICK_SIGN_SIGNATURES',
  ADD_ANNOTATION_TO_FILL = 'ADD_ANNOTATION_TO_FILL',
  REMOVE_ANNOTATION_TO_FILL = 'REMOVE_ANNOTATION_TO_FILL',
  VALIDATE_ANNOTATION_TO_FILL = 'VALIDATE_ANNOTATION_TO_FILL',
  VALIDATE_ANNOTATION_SIGNATURE = 'VALIDATE_ANNOTATION_SIGNATURE',

  ADD_GROUP_ANNOTATION_TO_FILL = 'ADD_GROUP_ANNOTATION_TO_FILL',
  REMOVE_GROUP_ANNOTATION_TO_FILL = 'REMOVE_GROUP_ANNOTATION_TO_FILL',
  VALIDATE_GROUP_ANNOTATION_TO_FILL = 'VALIDATE_GROUP_ANNOTATION_TO_FILL',

  NEXT_ANNOTATION = 'NEXT_ANNOTATION',
  ANNOTATION_VIEWED = 'ANNOTATION_VIEWED',
  PREVIOUS_ANNOTATION = 'PREVIOUS_ANNOTATION',
  SAVE_QUICK_SIGN_AS_TEMPLATE = 'SAVE_QUICK_SIGN_AS_TEMPLATE',
  ANNOTATION_CHANGED = 'ANNOTATION_CHANGED',
  FIELD_CHANGED = 'FIELD_CHANGED',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  FINISH_RENDERING = 'FINISH_RENDERING',
  GET_SIGN_AS_TEMPLATE = 'GET_SIGN_AS_TEMPLATE',

  ENABLE_ACTIONS = 'ENABLE_ACTIONS',
  DISABLE_ACTIONS = 'DISABLE_ACTIONS',

  USER_ACTIVE = 'USER_ACTIVE',
}
